// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1d6Kh","title":"AfterBackImages_title__3f0fU","images":"AfterBackImages_images__cqyca"};